import axios from "axios";
import { APIOverrides } from "../../ApiOverrides";
import type {
    BuyOpportunity,
    ExtractSuccessResponse,
    RouterContestProps,
    MarketContestProps
} from "../types";
import type { MyPlayerProps } from "../../types";

let AUTH_SVC_API = ''
let BR_SVC_API = ''


// Simpler named exports for common operations - these return the actual API response types
export const getPartners = () => BetRouterApi.BetRouter.PartnerApi.getPartners();
export const getLeagues = (status?: string) => BetRouterApi.BetRouter.LeagueApi.getLeagues(status);
export const getContests = (status?: string) => BetRouterApi.BetRouter.ContestApi.getRouterContests(status);
export const getParticipants = (router_league_id?: string, participant_type?: string, status?: string) =>
    BetRouterApi.BetRouter.ParticipantApi.getRouterParticipants(router_league_id, participant_type, status);

export const BetRouterApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        BR_SVC_API = endpoints['BR_SVC_API'] as string;
        console.log(BR_SVC_API)
    },
    BettorEdge: {
        // BettorEdge specific APIs would go here
        getMyDetails: async():Promise<MyPlayerProps| undefined> => {
            try {
                const resp = await axios.get(`${AUTH_SVC_API}/v1/players/player/me`)
                return resp.data.player
            } catch (e) {
                return undefined
            }
        }
    },
    BetRouter: {
        AccountApi: {
            // POST /accounts/join
            join: async(): Promise<ExtractSuccessResponse<'POST /accounts/join'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/accounts/join`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /accounts/leave
            leave: async(): Promise<ExtractSuccessResponse<'POST /accounts/leave'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/accounts/leave`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /accounts/me
            getMe: async(): Promise<ExtractSuccessResponse<'GET /accounts/me'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/accounts/me`);
                    return resp.data;
                } catch (e) {
                    console.log('ERROR')
                    console.log(e)
                    throw e;
                }
            },
            // GET /accounts/partners/me
            getMyPartner: async(partner_id: string): Promise<ExtractSuccessResponse<'GET /accounts/partners/me'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/accounts/partners/me`, {
                        params: { partner_id }
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /accounts/partner/connect
            connectPartner: async(partner_id: string): Promise<ExtractSuccessResponse<'POST /accounts/partner/connect'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/accounts/partner/connect`, { partner_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /accounts/partner/disconnect
            disconnectPartner: async(partner_id: string): Promise<ExtractSuccessResponse<'POST /accounts/partner/disconnect'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/accounts/partner/disconnect`, { partner_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /accounts/partner/credentials/update
            updatePartnerCredentials: async(partner_id: string, credentials: Record<string, any>): Promise<ExtractSuccessResponse<'POST /accounts/partner/credentials/update'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/accounts/partner/credentials/update`, { partner_id, credentials });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /accounts/partner/credentials/test
            testPartnerCredentials: async(partner_id: string): Promise<ExtractSuccessResponse<'POST /accounts/partner/credentials/test'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/accounts/partner/credentials/test`, { partner_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /accounts/balance/update
            updateBalance: async(): Promise<ExtractSuccessResponse<'POST /accounts/balance/update'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/accounts/balance/update`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /accounts/balance/me
            getMyBalance: async(): Promise<ExtractSuccessResponse<'GET /accounts/balance/me'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/accounts/balance/me`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        },
        OpportunityApi: {
            // GET /opportunities/open/me
            getMyOpenOpportunities: async(): Promise<ExtractSuccessResponse<'GET /opportunities/open/me'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/opportunities/open/me`);
                    return resp.data;
                } catch (e) {
                    console.log(e);
                    return {
                        message: 'Error fetching opportunities',
                        opportunities: [],
                        opportunity_status_legs: [],
                        router_orders: [],
                        router_contests: []
                    };
                }
            },
            // GET /opportunities/past/me
            getMyPastOpportunities: async(from: number, to: number, offset: number = 0): Promise<ExtractSuccessResponse<'GET /opportunities/past/me'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/opportunities/past/me`, {
                        params: { from, to, offset }
                    });
                    return resp.data;
                } catch (e) {
                    console.log(e);
                    return {
                        message: 'Error fetching past opportunities',
                        opportunities: [],
                        opportunity_summary: [],
                        router_contests:[],
                        router_orders:[],
                        opportunity_status_legs: [],
                        pages: 0
                    };
                }
            },
            // POST /opportunities/opportunity/buy
            buyOpportunity: async(buy_opportunity: BuyOpportunity): Promise<ExtractSuccessResponse<'POST /opportunities/opportunity/buy'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/opportunities/opportunity/buy`, { buy_opportunity });
                    console.log(resp.data);
                    return resp.data;
                } catch (e) {
                    console.log(e);
                    return {
                        message: 'Error buying opportunity',
                        success: false,
                        total_legs: 0,
                        successful_orders: 0,
                        router_orders: [],
                        buy_results: []
                    };
                }
            },
            // POST /opportunities/reconcile
            reconcileOpportunities: async(): Promise<ExtractSuccessResponse<'POST /opportunities/reconcile'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/opportunities/reconcile`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        },
        PartnerApi: {
            // GET /partners
            getPartners: async(): Promise<ExtractSuccessResponse<'GET /partners'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/partners`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /partners/load
            loadPartners: async(): Promise<ExtractSuccessResponse<'POST /partners/load'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/partners/load`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        },
        LeagueApi: {
            // GET /leagues
            getLeagues: async(status?: string): Promise<ExtractSuccessResponse<'GET /leagues'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/leagues`, {
                        params: status ? { status } : undefined
                    });
                    return resp.data;
                } catch (e) {
                    console.log('ERROR', e);
                    throw e;
                }
            },
            // GET /leagues/open
            getOpenLeagues: async(): Promise<ExtractSuccessResponse<'GET /leagues/open'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/leagues/open`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /leagues/link
            linkLeague: async(raw_league_ids: string | string[], router_league_id: string): Promise<ExtractSuccessResponse<'POST /leagues/link'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/leagues/link`, { raw_league_ids, router_league_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /leagues/load
            loadLeagues: async(): Promise<ExtractSuccessResponse<'POST /leagues/load'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/leagues/load`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /leagues/:router_league_id/available-raw/:partner_id
            getAvailableRawLeagues: async(router_league_id: string, partner_id: string): Promise<ExtractSuccessResponse<'GET /leagues/:router_league_id/available-raw/:partner_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/leagues/${router_league_id}/available-raw/${partner_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        },
        ParticipantApi: {
            // GET /participants/router
            getRouterParticipants: async(router_league_id?: string, participant_type?: string, status?: string): Promise<ExtractSuccessResponse<'GET /participants/router'>> => {
                try {
                    const params: any = {};
                    if (router_league_id) params.router_league_id = router_league_id;
                    if (participant_type) params.participant_type = participant_type;
                    if (status) params.status = status;

                    const resp = await axios.get(`${BR_SVC_API}/participants/router`, {
                        params: Object.keys(params).length > 0 ? params : undefined
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /participants/raw
            getRawParticipants: async(): Promise<ExtractSuccessResponse<'GET /participants/raw'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/participants/raw`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /participants/partner
            getPartnerParticipants: async(): Promise<ExtractSuccessResponse<'GET /participants/partner'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/participants/partner`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /participants/:router_participant_id/available-raw/:partner_id/:router_league_id
            getAvailableRawParticipants: async(router_participant_id: string, partner_id: string, router_league_id: string): Promise<ExtractSuccessResponse<'GET /participants/:router_participant_id/available-raw/:partner_id/:router_league_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/participants/${router_participant_id}/available-raw/${partner_id}/${router_league_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /participants/link
            linkParticipant: async(raw_participant_ids: string | string[], router_participant_id: string): Promise<ExtractSuccessResponse<'POST /participants/link'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/participants/link`, { raw_participant_ids, router_participant_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /participants/load
            loadParticipants: async(router_league_id: string): Promise<ExtractSuccessResponse<'POST /participants/load'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/participants/load`, { router_league_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /participants/load-raw
            loadRawParticipants: async(partner_id: string, router_league_id: string): Promise<ExtractSuccessResponse<'POST /participants/load-raw'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/participants/load-raw`, { partner_id, router_league_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        },
        ContestApi: {
            // GET /contests/router
            getRouterContests: async(status?: string): Promise<ExtractSuccessResponse<'GET /contests/router'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/contests/router`, {
                        params: status ? { status } : undefined
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /contests/partner
            getPartnerContests: async(): Promise<ExtractSuccessResponse<'GET /contests/partner'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/contests/partner`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /contests/:router_contest_id
            getContest: async(router_contest_id: string): Promise<ExtractSuccessResponse<'GET /contests/:router_contest_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/contests/${router_contest_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /contests/open/:router_league_id
            getOpenContests: async(router_league_id: string, status: 'open' | 'closed' = 'open', offset?: number): Promise<ExtractSuccessResponse<'GET /contests/open/:router_league_id'>> => {
                try {
                    const params: any = { status };
                    if (status === 'closed' && offset !== undefined) {
                        params.offset = offset;
                    }
                    const resp = await axios.get(`${BR_SVC_API}/contests/open/${router_league_id}`, {
                        params
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /contests/link
            linkContest: async(raw_contest_ids: string[], router_contest_id: string): Promise<ExtractSuccessResponse<'POST /contests/link'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/contests/link`, { raw_contest_ids, router_contest_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /contests/load
            loadContests: async(router_league_id: string): Promise<ExtractSuccessResponse<'POST /contests/load'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/contests/load`, { router_league_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /contests/load-raw
            loadRawContests: async(partner_id: string, router_league_id: string): Promise<ExtractSuccessResponse<'POST /contests/load-raw'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/contests/load-raw`, { partner_id, router_league_id });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /contests/check-status
            checkStatus: async(): Promise<ExtractSuccessResponse<'POST /contests/check-status'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/contests/check-status`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // PATCH /contests/router/:router_contest_id
            updateRouterContest: async(router_contest_id: string, updates: Partial<RouterContestProps>): Promise<ExtractSuccessResponse<'PATCH /contests/router/:router_contest_id'>> => {
                try {
                    const resp = await axios.patch(`${BR_SVC_API}/contests/router/${router_contest_id}`, updates);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /contests/:router_contest_id/available-raw/:partner_id
            getAvailableRawContests: async(router_contest_id: string, partner_id: string): Promise<ExtractSuccessResponse<'GET /contests/:router_contest_id/available-raw/:partner_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/contests/${router_contest_id}/available-raw/${partner_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /contests/auto-fill
            getAutoFillContests: async(): Promise<ExtractSuccessResponse<'GET /contests/auto-fill'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/contests/auto-fill`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        },
        MarketApi: {
            // GET /markets/router
            getRouterMarkets: async(): Promise<ExtractSuccessResponse<'GET /markets/router'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/router`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /markets/variables
            getMarketVariables: async(): Promise<ExtractSuccessResponse<'GET /markets/variables'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/variables`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /markets/sides
            getMarketSides: async(): Promise<ExtractSuccessResponse<'GET /markets/sides'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/sides`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /markets/partner
            getPartnerMarkets: async(): Promise<ExtractSuccessResponse<'GET /markets/partner'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/partner`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /markets/raw/:router_contest_id
            getOpenMarkets: async(router_contest_id: string): Promise<ExtractSuccessResponse<'GET /markets/raw/:router_contest_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/raw/${router_contest_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /markets/load
            loadMarkets: async(): Promise<ExtractSuccessResponse<'POST /markets/load'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/markets/load`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /markets/link
            linkMarket: async(
                raw_market_id: string,
                router_market_id: string,
                market_side_id: string,
                partner_participant_id: string,
                timeframe_id: string,
                variable: number,
                variable_type: 'total' | 'spread',
                price_key?: string
            ): Promise<ExtractSuccessResponse<'POST /markets/link'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/markets/link`, {
                        raw_market_id,
                        router_market_id,
                        market_side_id,
                        partner_participant_id,
                        timeframe_id,
                        variable,
                        variable_type,
                        price_key
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /markets/supported/:router_contest_id
            getSupportedMarkets: async(router_contest_id: string): Promise<ExtractSuccessResponse<'GET /markets/supported/:router_contest_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/supported/${router_contest_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /markets/available-to-support/:router_contest_id
            getAvailableToSupport: async(router_contest_id: string): Promise<ExtractSuccessResponse<'GET /markets/available-to-support/:router_contest_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/available-to-support/${router_contest_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /markets/supported
            addSupportedMarket: async(router_contest_id: string, router_market_id: string): Promise<ExtractSuccessResponse<'POST /markets/supported'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/markets/supported`, {
                        router_contest_id,
                        router_market_id
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // DELETE /markets/supported/:market_contest_id
            removeSupportedMarket: async(market_contest_id: string): Promise<ExtractSuccessResponse<'DELETE /markets/supported/:market_contest_id'>> => {
                try {
                    const resp = await axios.delete(`${BR_SVC_API}/markets/supported/${market_contest_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // PATCH /markets/supported/:market_contest_id
            updateMarketContest: async(market_contest_id: string, updates: Partial<MarketContestProps>): Promise<ExtractSuccessResponse<'PATCH /markets/supported/:market_contest_id'>> => {
                try {
                    const resp = await axios.patch(`${BR_SVC_API}/markets/supported/${market_contest_id}`, updates);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /markets/:router_contest_id/:router_market_id/available-raw/:partner_id
            getAvailableRawMarkets: async(router_contest_id: string, router_market_id: string, partner_id: string): Promise<ExtractSuccessResponse<'GET /markets/:router_contest_id/:router_market_id/available-raw/:partner_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/${router_contest_id}/${router_market_id}/available-raw/${partner_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /markets/:router_contest_id/:router_market_id/linking-data/:partner_id
            getMarketLinkingData: async(router_contest_id: string, router_market_id: string, partner_id: string): Promise<ExtractSuccessResponse<'GET /markets/:router_contest_id/:router_market_id/linking-data/:partner_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/${router_contest_id}/${router_market_id}/linking-data/${partner_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /markets/:router_contest_id/:router_market_id/variables-and-raw/:partner_id
            getVariablesAndRaw: async(router_contest_id: string, router_market_id: string, partner_id: string): Promise<ExtractSuccessResponse<'GET /markets/:router_contest_id/:router_market_id/variables-and-raw/:partner_id'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/markets/${router_contest_id}/${router_market_id}/variables-and-raw/${partner_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /markets/add-variable
            addVariable: async(router_contest_id: string, router_market_id: string, partner_id: string, variable: number): Promise<ExtractSuccessResponse<'POST /markets/add-variable'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/markets/add-variable`, {
                        router_contest_id,
                        router_market_id,
                        partner_id,
                        variable
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /markets/router
            createRouterMarket: async(
                market_key: string,
                market_label: string,
                market_description: string,
                category: 'game_result' | 'team_stat' | 'player_stat' | 'game_stat',
                variable_required: boolean,
                default_variable_type: 'total' | 'spread',
                allow_multiple_participants: boolean,
                participant_type: 'team' | 'player' | 'event',
                status: 'active' | 'inactive'
            ): Promise<ExtractSuccessResponse<'POST /markets/router'> | any> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/markets/router`, {
                        market_key,
                        market_label,
                        market_description,
                        category,
                        variable_required,
                        default_variable_type,
                        allow_multiple_participants,
                        participant_type,
                        status
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // PATCH /markets/router/:router_market_id
            updateRouterMarket: async(router_market_id: string, updates: Partial<{
                market_key: string;
                market_label: string;
                market_description: string;
                category: 'game_result' | 'team_stat' | 'player_stat' | 'game_stat';
                variable_required: boolean;
                default_variable_type: 'total' | 'spread';
                allow_multiple_participants: boolean;
                participant_type: 'team' | 'player' | 'event';
                status: 'active' | 'inactive';
            }>): Promise<ExtractSuccessResponse<'PATCH /markets/router/:router_market_id'>> => {
                try {
                    const resp = await axios.patch(`${BR_SVC_API}/markets/router/${router_market_id}`, updates);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // DELETE /markets/router/:router_market_id
            deleteRouterMarket: async(router_market_id: string): Promise<ExtractSuccessResponse<'DELETE /markets/router/:router_market_id'>> => {
                try {
                    const resp = await axios.delete(`${BR_SVC_API}/markets/router/${router_market_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /markets/sides
            createMarketSide: async(
                router_market_id: string,
                side_type: string,
                side_key: string,
                renderer: string
            ): Promise<ExtractSuccessResponse<'POST /markets/sides'> | any> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/markets/sides`, {
                        router_market_id,
                        side_type,
                        side_key,
                        renderer
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // PATCH /markets/sides/:market_side_id
            updateMarketSide: async(market_side_id: string, updates: Partial<{
                router_market_id: string;
                side_type: string;
                side_key: string;
                renderer: string;
            }>): Promise<ExtractSuccessResponse<'PATCH /markets/sides/:market_side_id'>> => {
                try {
                    const resp = await axios.patch(`${BR_SVC_API}/markets/sides/${market_side_id}`, updates);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // DELETE /markets/sides/:market_side_id
            deleteMarketSide: async(market_side_id: string): Promise<ExtractSuccessResponse<'DELETE /markets/sides/:market_side_id'>> => {
                try {
                    const resp = await axios.delete(`${BR_SVC_API}/markets/sides/${market_side_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        },
        LiquidityApi: {
            // GET /liquidity/contest/:router_contest_id
            getLiquidity: async(router_contest_id: string, partner_ids?: string[], include_opportunities?: boolean): Promise<ExtractSuccessResponse<'GET /liquidity/contest/:router_contest_id'>> => {
                try {
                    const params: any = {};
                    if (partner_ids && partner_ids.length > 0) {
                        params.partner_ids = partner_ids.join(',');
                    }
                    if (include_opportunities) {
                        params.include_opportunities = 'true';
                    }
                    const resp = await axios.get(`${BR_SVC_API}/liquidity/contest/${router_contest_id}`, { params });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /liquidity/generate-all
            getAllOpportunities: async(): Promise<ExtractSuccessResponse<'POST /liquidity/generate-all'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/liquidity/generate-all`);
                    return resp.data;
                } catch (e) {
                    console.log(e);
                    return {
                        message: 'Error generating opportunities',
                        contests_processed: 0,
                        total_liquidity_count: 0,
                        total_opportunities: 0,
                        opportunities: [],
                        router_contests: [],
                        partner_markets: [],
                        router_market_variables: [],
                        router_markets: [],
                        router_market_sides: [],
                        partners: []
                    };
                }
            }
        },
        AutoLinkingApi: {
            // POST /autolinking/contests
            autoLinkContests: async(router_league_id: string, partner_id: string): Promise<ExtractSuccessResponse<'POST /autolinking/contests'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/autolinking/contests`, {
                        router_league_id,
                        partner_id
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /autolinking/participants
            autoLinkParticipants: async(router_league_id: string, partner_id: string): Promise<ExtractSuccessResponse<'POST /autolinking/participants'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/autolinking/participants`, {
                        router_league_id,
                        partner_id
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /autolinking/markets
            autoLinkMarkets: async(router_league_id: string, router_market_id: string, partner_id: string): Promise<ExtractSuccessResponse<'POST /autolinking/markets'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/autolinking/markets`, {
                        router_league_id,
                        router_market_id,
                        partner_id
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        },
        JobApi: {
            // GET /jobs
            getJobs: async(): Promise<ExtractSuccessResponse<'GET /jobs'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/jobs`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /jobs/:job_key
            getJob: async(job_key: string): Promise<ExtractSuccessResponse<'GET /jobs/:job_key'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/jobs/${job_key}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /jobs/create
            createJob: async(job_key: string, name: string, description: string, frequency: number, frequency_type: 'seconds' | 'minutes' | 'hours' | 'days'): Promise<ExtractSuccessResponse<'POST /jobs/create'> | any> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/jobs/create`, {
                        job_key,
                        name,
                        description,
                        frequency,
                        frequency_type
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // PUT /jobs/update
            updateJob: async(router_job_id: string, updates: {
                name?: string;
                description?: string;
                frequency?: number;
                frequency_type?: 'minutes' | 'hours' | 'days';
            }): Promise<ExtractSuccessResponse<'PUT /jobs/update'>> => {
                try {
                    const resp = await axios.put(`${BR_SVC_API}/jobs/update`, {
                        router_job_id,
                        ...updates
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // DELETE /jobs/:router_job_id
            deleteJob: async(router_job_id: string): Promise<ExtractSuccessResponse<'DELETE /jobs/:router_job_id'>> => {
                try {
                    const resp = await axios.delete(`${BR_SVC_API}/jobs/${router_job_id}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /jobs/queue
            queueJob: async(job_key: string): Promise<ExtractSuccessResponse<'POST /jobs/queue'>> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/jobs/queue`, { job_key });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /jobs/statuses/recent
            getRecentStatuses: async(limit?: number, offset?: number): Promise<ExtractSuccessResponse<'GET /jobs/statuses/recent'>> => {
                try {
                    const params: any = {};
                    if (limit !== undefined) params.limit = limit;
                    if (offset !== undefined) params.offset = offset;

                    const resp = await axios.get(`${BR_SVC_API}/jobs/statuses/recent`, {
                        params: Object.keys(params).length > 0 ? params : undefined
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        },
        ConfigApi: {
            // GET /config
            getConfigs: async(): Promise<ExtractSuccessResponse<'GET /config'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/config`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /config/:config
            getConfig: async(config: string): Promise<ExtractSuccessResponse<'GET /config/:config'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/config/${config}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // GET /config/:config/value
            getConfigValue: async(config: string): Promise<ExtractSuccessResponse<'GET /config/:config/value'>> => {
                try {
                    const resp = await axios.get(`${BR_SVC_API}/config/${config}/value`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // POST /config
            createConfig: async(config: string, value: any, config_format: 'string' | 'number' | 'boolean' | 'json'): Promise<ExtractSuccessResponse<'POST /config'> | any> => {
                try {
                    const resp = await axios.post(`${BR_SVC_API}/config`, {
                        config,
                        value,
                        config_format
                    });
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // PUT /config/:config
            updateConfig: async(config: string, value?: any, config_format?: 'string' | 'number' | 'boolean' | 'json'): Promise<ExtractSuccessResponse<'PUT /config/:config'>> => {
                try {
                    const body: any = {};
                    if (value !== undefined) body.value = value;
                    if (config_format !== undefined) body.config_format = config_format;

                    const resp = await axios.put(`${BR_SVC_API}/config/${config}`, body);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            },
            // DELETE /config/:config
            deleteConfig: async(config: string): Promise<ExtractSuccessResponse<'DELETE /config/:config'>> => {
                try {
                    const resp = await axios.delete(`${BR_SVC_API}/config/${config}`);
                    return resp.data;
                } catch (e) {
                    throw e;
                }
            }
        }
    }
}
